import { Check } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "~/components/ui/toggle-group";
import { SEARCH_ENTITY_TYPES, SearchEntityType } from "~/services/search";
import { ENTITY_TYPE_LABEL, entityIcon } from "./constants";

interface EntityTypeFilterProps {
  value: SearchEntityType[];
  onChange: (value: SearchEntityType[]) => void;
}

/**
 * Which entity types a search or index run covers. The last selected type stays
 * pressed, since an empty filter would be ambiguous. A check marks selection
 * because the toggle's `accent` tint is also its hover state.
 */
export const EntityTypeFilter = ({ value, onChange }: EntityTypeFilterProps) => (
  <ToggleGroup
    type="multiple"
    variant="outline"
    size="sm"
    value={value}
    onValueChange={(next: string[]) => {
      if (next.length > 0) onChange(next as SearchEntityType[]);
    }}
    aria-label="Entity types"
  >
    {SEARCH_ENTITY_TYPES.map((entityType) => (
      <ToggleGroupItem
        key={entityType}
        value={entityType}
        className="gap-1.5 px-3 text-muted-foreground data-[state=on]:font-semibold data-[state=on]:text-foreground"
      >
        {entityIcon(entityType)}
        {ENTITY_TYPE_LABEL[entityType]}
        {/* Kept in the layout so toggling does not resize the row. */}
        <Check className={value.includes(entityType) ? "size-3.5" : "size-3.5 invisible"} />
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
);
